import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import KabobMenuItem from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuItem';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const DuplicateScenarioKabobItem = () => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { pageContentResource } = usePageContentContext();
  const { loadModalCollectionByLink } = useModalContext();

  const handleDuplicateScenarioClick = () => {
    const duplicateLink = pageContentResource?.relationship(fr.relationships.facetPlanViewDuplicatePlan.name).link('related');
    if (!duplicateLink) {
      return;
    }
    loadModalCollectionByLink(duplicateLink.url());
    logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'duplicate scenario from summary kabob', {
      eventProperties: {
        scenarioId: pageContentResource.id(),
      },
    });
  };

  return (
    <KabobMenuItem
      label={'Duplicate Scenario'}
      test={'facet-plan-summary-kabob-item-duplicate'}
      onClick={() => {
        handleDuplicateScenarioClick();
      }}
    />
  );
};

DuplicateScenarioKabobItem.defaultProps = {};

DuplicateScenarioKabobItem.propTypes = {};

export default DuplicateScenarioKabobItem;
